import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDBox, FDStack,
} from '@facet-wealth/design';
import {
  ItemSummary,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/ItemSummary';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { noop } from 'lodash';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('description', {
    _component: () => Text,
    _customProps: {
      color: 'primaryGray2',
      variant: 'h6',
      align: 'left',
    },
  }, overrideReadOnly)
  .nameOverride('balance', {
    _component: () => FDBodyText,
  }, overrideReadOnly);


const ItemSummaries = ({ itemSummaryCollection, onRefresh }) => {
  const itemSummaries = itemSummaryCollection.resources().list();
  return (
    <FDStack direction={'column'}>
      {
          itemSummaries.map((item, i) => {
            // due to all of the items needing to be encapsulated within a box with a border radius
            // and all of the items needing to darken on hover, we need to pass in first and
            // last item props to know which corners need a border radius
            const isFirstItem = i === 0;
            const isLastItem = i === (itemSummaries.length - 1);
            return (
              <FDBox key={item.id()}>
                <MetaResourceRenderer
                  key={item.id()}
                  resource={item}
                  layout={ItemSummary}
                  LayoutProps={{
                    isFirstItem,
                    isLastItem,
                    onRefresh,
                  }}
                  metaOverrideSet={metaOverrideSet}
                />
              </FDBox>);
          })
        }
    </FDStack>
  );
};

ItemSummaries.defaultProps = {
  onRefresh: noop,
};

ItemSummaries.propTypes = {
  itemSummaryCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  onRefresh: PropTypes.func,
};

export { ItemSummaries };
